// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1960":"cb05847bdfaf90fc","2888":"7b047dfc7d23a523","8633":"d3d38d61268c7f40","8663":"ee27095c3ca0ea86","8986":"cc091be3670e4fab","9106":"98c6bf57e987b602"}[chunkId] + ".css";
};